import { render } from "./Pagenotfound.vue?vue&type=template&id=0da1b598&bindings={}"
import script from "./Pagenotfound.vue?vue&type=script&lang=js"
export * from "./Pagenotfound.vue?vue&type=script&lang=js"
script.render = render

export default script